<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><a id="page-ix"></a><span class="center"><em>For Kevin,</em></span></p>
<p class="ded1"><span class="center"><em>Still and always, best of sisters!</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?76ab1199